import { render, staticRenderFns } from "./appointmentDeliveryBatch.vue?vue&type=template&id=f24a0266&scoped=true&"
import script from "./appointmentDeliveryBatch.vue?vue&type=script&lang=js&"
export * from "./appointmentDeliveryBatch.vue?vue&type=script&lang=js&"
import style0 from "./appointmentDeliveryBatch.vue?vue&type=style&index=0&id=f24a0266&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24a0266",
  null
  
)

export default component.exports